import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import useRoles from "@/features/role/hooks/useRoles";
import { transformUserToRequest } from "@/features/shared/utils/helpers";
import { Input } from "@material-tailwind/react";
const defaultUser = {
    id: 0,
    first_name: '',
    last_name: '',
    email: '',
    indic_actif: 1,
    manager_id: null,
    role: {
        id: 0,
        code: "",
        label: "",
        hierarchy: 0,
        is_active: true,
        permissions: [],
        created_at: "",
        updated_at: "",
    }
};
const UserForm = ({ initialData, managers, onSubmit, onCancel }) => {
    const [formData, setFormData] = useState(initialData ? {
        ...initialData,
        role_id: initialData.role?.id ?? initialData.role_id,
        manager_id: initialData.manager_id ?? initialData.manager?.id ?? null,
    } : defaultUser);
    const { roles } = useRoles();
    const [errors, setErrors] = useState({});
    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prev => {
            if (!prev)
                return defaultUser;
            const updatedFormData = {
                ...prev,
                [name]: type === 'checkbox'
                    ? (e.target.checked ? 1 : 0) // Accéder à checked si c'est une checkbox
                    : (name === 'role_id'
                        ? parseInt(value, 10)
                        : name === 'manager_id'
                            ? (value === '' ? null : parseInt(value, 10))
                            : value),
            };
            return updatedFormData;
        });
    };
    const validateFields = () => {
        const newErrors = {};
        if (!formData.first_name.trim()) {
            newErrors.first_name = "Le nom est obligatoire.";
        }
        else if (formData.first_name.length < 3) {
            newErrors.first_name = "Le nom doit contenir au moins 3 caractères.";
        }
        if (!formData.last_name.trim()) {
            newErrors.last_name = "Le prénom est obligatoire.";
        }
        else if (formData.last_name.length < 3) {
            newErrors.last_name = "Le prénom doit contenir au moins 3 caractères.";
        }
        if (!formData.email.trim()) {
            newErrors.email = "L'adresse mail est obligatoire.";
        }
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "L'adresse mail n'est pas valide.";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = () => {
        if (!validateFields()) {
            return;
        }
        if (formData) {
            onSubmit(formData.id, transformUserToRequest(formData));
        }
    };
    return (_jsxs("div", { className: "bg-white w-full", children: [_jsxs("div", { className: "flex flex-col md:flex-row justify-between items-center border-b p-4 bg-gray-100", children: [initialData &&
                        _jsx("h1", { className: "text-l font-bold", children: _jsxs("span", { className: "text-blue-900", children: [" Modification de l'utilisateur : `", initialData.first_name ?? "", " ", initialData.last_name ?? "", "`"] }) }), !initialData &&
                        _jsx("h1", { className: "text-l font-bold", children: _jsx("span", { className: "text-blue-900", children: "Ajouter un utilisateur" }) })] }), _jsxs("form", { className: "flex flex-col gap-4 p-2", children: [_jsx("div", { className: "pt-2", children: _jsx(Input, { variant: "standard", label: "Pr\u00E9nom", value: formData?.first_name ?? '', type: "text", name: "first_name", placeholder: "Pr\u00E9nom", onChange: handleChange, className: "w-full", crossOrigin: "" }) }), errors.first_name && (_jsx("p", { className: "text-sm text-red-500 mt-1", children: errors.first_name })), _jsx("div", { className: "pt-2", children: _jsx(Input, { variant: "standard", label: "Nom", value: formData?.last_name ?? '', type: "text", name: "last_name", placeholder: "Nom", onChange: handleChange, className: "w-full", crossOrigin: "" }) }), errors.last_name && (_jsx("p", { className: "text-sm text-red-500 mt-1", children: errors.last_name })), _jsx("div", { className: "pt-2", children: _jsx(Input, { variant: "standard", label: "Email", value: formData?.email ?? '', type: "email", name: "email", placeholder: "Email", onChange: handleChange, className: "w-full", crossOrigin: "" }) }), errors.email && (_jsx("p", { className: "text-sm text-red-500 mt-1", children: errors.email })), _jsx("select", { name: "role_id", value: formData?.role_id ?? roles[0]?.id ?? 4, onChange: handleChange, className: "border p-2 rounded", children: roles.map((role) => (_jsx("option", { value: role.id, children: role.label }, role.id))) }), _jsxs("label", { className: "flex items-center gap-2", children: [_jsx("input", { type: "checkbox", name: "indic_actif", checked: formData?.indic_actif === 1, onChange: handleChange, className: "w-4 h-4" }), "Actif"] }), _jsxs("div", { className: "flex flex-col gap-2", children: [_jsx("label", { className: "font-medium", children: "Manager" }), _jsxs("select", { name: "manager_id", value: formData?.manager_id ?? '', onChange: handleChange, className: "border p-2 rounded", children: [_jsx("option", { value: "", children: "Aucun manager" }), managers
                                        .filter((manager) => manager.id !== formData?.id)
                                        .map((manager) => (_jsxs("option", { value: manager.id, children: [manager.first_name, " ", manager.last_name] }, manager.id)))] })] }), _jsxs("div", { className: "mt-6 flex flex-col sm:flex-row justify-end gap-4 p-2", children: [_jsx("button", { type: "button", onClick: onCancel, className: "bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600", children: "Annuler" }), _jsx("button", { type: "button", onClick: handleSubmit, className: "bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600", children: "Sauvegarder" })] })] })] }));
};
export default UserForm;
